module.exports = __webpack_public_path__ + "img/alipay.fdade419.png";